import GCS from "../../../../contents/docs/cdp/sources/_snippets/source-gcs.mdx";
import * as React from 'react';
export default {
  GCS,
  React
};